export const ALERT_SHOW = 'ALERT_SHOW';
export const ALERT_SET_MESSAGE = 'ALERT_SET_MESSAGE';
